import * as React from "react";

import { AutocompleteProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/input/autocomplete";

import { Wiedervorlagenzuweisung } from "../modules/assignment/components/AssigneePicker";

import { ComponentContext } from "./ComponentContext";

export function capitalize<T extends string>(value: T): Capitalize<T> {
	return (value.charAt(0).toUpperCase() + value.slice(1)) as Capitalize<T>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-function-type
export function getDecoratorComponentName(Component: React.ComponentType<any>, func: Function): string {
	return [Component.displayName ?? Component.name, "With", capitalize(func.name)].join("");
}

export function assigneePickerDecorator<T extends AutocompleteProps>(
	Component: React.ComponentType<T>
): React.ComponentType<T> {
	const displayName = getDecoratorComponentName(Component, assigneePickerDecorator);
	return Object.assign(
		(props: T) => {
			const component = React.useContext(ComponentContext);

			if (component === "Wiedervorlagenzuweisung") {
				return <Wiedervorlagenzuweisung {...props} />;
			}

			return <Component {...props} />;
		},
		{ displayName: displayName }
	);
}
